export const LV = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11563)">
      <g clipPath="url(#clip1_1073_11563)">
      <rect x="96" y="60" width="96" height="24" transform="rotate(180 96 60)" fill="white"/>
      <rect x="96" y="96" width="96" height="36" transform="rotate(180 96 96)" fill="#911C1C"/>
      <rect x="96" y="36" width="96" height="36" transform="rotate(180 96 36)" fill="#911C1C"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11563">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11563">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
